import { NgModule } from '@angular/core';
import { CapitalizeModule } from './capitalize';
import { DateFormatPipeModule } from './date-format';
import { ElementPipeModule } from './element';
import { FamilyCompositionPipeModule } from './family-composition';
import { HighlightModule } from './highlight';
import { KentekenModule } from './kenteken';
import { KilometrageModule } from './kilometrage';
import { LicenseplatePipeModule } from './licenseplate';
import { MileageCarPipeModule } from './mileage-car';
import { MileageMotorcycleModule } from './mileage-motorcycle';
import { PrettyPricePipeModule } from './pretty-price';
import { SanitizePipeModule } from './sanitize';
import { TooltipModule } from './tooltip/tooltip.module';
import { ReplaceNonBreakingSpacePipe } from './replace-non-breaking-space/replace-non-breaking-space.pipe';

@NgModule({
    imports: [
        CapitalizeModule,
        DateFormatPipeModule,
        ElementPipeModule,
        FamilyCompositionPipeModule,
        HighlightModule,
        KentekenModule,
        KilometrageModule,
        LicenseplatePipeModule,
        MileageCarPipeModule,
        MileageMotorcycleModule,
        PrettyPricePipeModule,
        SanitizePipeModule,
        TooltipModule,
        ReplaceNonBreakingSpacePipe
    ],
    exports: [
        CapitalizeModule,
        DateFormatPipeModule,
        ElementPipeModule,
        FamilyCompositionPipeModule,
        HighlightModule,
        KentekenModule,
        KilometrageModule,
        LicenseplatePipeModule,
        MileageCarPipeModule,
        MileageMotorcycleModule,
        PrettyPricePipeModule,
        SanitizePipeModule,
        TooltipModule,
        ReplaceNonBreakingSpacePipe
    ],
})
export class PipesModule { }
